var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCwMap(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.591,
    height: 27.889,
    viewBox: "0 0 23.591 27.889",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "side0",
    transform: "translate(-39.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7843",
    "data-name": "Group 7843",
    transform: "translate(39.451)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7842",
    "data-name": "Group 7842"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15473",
    "data-name": "Path 15473",
    d: "M59.587,3.455A11.8,11.8,0,0,0,39.451,11.8c0,6.374,6.026,11.675,9.264,14.523.45.4.838.738,1.148,1.027a2.032,2.032,0,0,0,2.767,0c.31-.289.7-.631,1.148-1.027,3.238-2.848,9.264-8.149,9.264-14.523A11.719,11.719,0,0,0,59.587,3.455ZM52.7,25.092c-.46.4-.857.754-1.184,1.06a.394.394,0,0,1-.536,0c-.327-.306-.724-.655-1.184-1.06-3.044-2.677-8.71-7.661-8.71-13.3a10.162,10.162,0,0,1,20.324,0C61.408,17.43,55.743,22.414,52.7,25.092Z",
    transform: "translate(-39.451 0)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7845",
    "data-name": "Group 7845",
    transform: "translate(46.048 6.152)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7844",
    "data-name": "Group 7844"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15474",
    "data-name": "Path 15474",
    d: "M165.768,112.938a5.2,5.2,0,1,0,5.2,5.2A5.2,5.2,0,0,0,165.768,112.938Zm0,8.762a3.564,3.564,0,1,1,3.564-3.564A3.569,3.569,0,0,1,165.768,121.7Z",
    transform: "translate(-160.57 -112.938)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCwMap);
export default __webpack_public_path__ + "static/media/icon-cw-map.b7a605cea6706f311a5e307e7d984b17.svg";
export { ForwardRef as ReactComponent };